import { Injectable } from '@angular/core';
import { CartType, TinyCart } from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { Converter } from '../../../../core/util';

@Injectable({ providedIn: 'root' })
export class TinyCartNormalizer implements Converter<Occ.TinyCart, TinyCart> {
  convert(source: Occ.TinyCart, target?: TinyCart): TinyCart {
    if (source) {
      target = this.convertTinyCart(source);
    }

    return target;
  }

  private convertTinyCart(source: Occ.TinyCart): TinyCart {
    if (source) {
      return {
        ...source,
        cartType: source.cartType as CartType,
      };
    } else {
      return undefined;
    }
  }
}
